module.exports = __webpack_public_path__ + "static/Lato-Bold-cccb897485813c7c256901dbca54ecf2.woff2";